export function getEnv(
  key:
    | "REACT_APP_ENV"
    | "REACT_APP_APP_NAME"
    | "REACT_APP_REDUX_PERSIST_STORE_KEY"
    | "REACT_APP_URL_PUBLIC"
    | "REACT_APP_SERVER_API_URL"
    | "REACT_APP_SERVER_ENTITY_TRACKER_API_URL"
    | "REACT_APP_AZURE_AUTH_CLIENT_ID"
    | "REACT_APP_AZURE_AUTH_AUTHORITY"
    | "REACT_APP_AZURE_AUTH_REDIRECT_URI"
    | "REACT_APP_NOTIFIER_PROJECT_NAME"
    | "REACT_APP_NOTIFIER_SERVER_API_URL"
    | "REACT_APP_SHAREPOINT_SITE_URL"
    | "REACT_APP_GRAPH_API_URL"
    | "REACT_APP_GRAPH_API_BETA_URL"
    | "REACT_APP_SP_SITE_ID"
    | "REACT_APP_EMPLOYEE_SP_LIST_ID"
    | "REACT_APP_MEETING_TEMPLATE_SP_LIST_ID"
    | "REACT_APP_LEAVE_REQUEST_SP_LIST_ID"
    | "REACT_APP_SYSTEM_MGMT_SP_LIST_ID"
    | "REACT_APP_IT_CODE_REQUEST_SP_LIST_ID"
    | "REACT_APP_MAIL_TEMPLATE_SP_LIST_ID"
    | "REACT_APP_TRAINING_COURSE_SP_LIST_ID"
    | "REACT_APP_TRAINING_COURSE_REGISTRATION_SP_LIST_ID"
    | "REACT_APP_TRAINING_PLAN_SP_LIST_ID"
    | "REACT_APP_FOLDER_AND_FILE_SP_LIST_ID"
    | "REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID"
    | "REACT_APP_WORKING_DOCS_INF_LIST_ID"
    | "REACT_APP_WORKING_DOCS_HIS_INF_LIST_ID"
    | "REACT_APP_WORKING_DOCS_PUBLISH_INF_LIST_ID"
    | "REACT_APP_DOCUMENT_TYPES_LIST_ID"
    | "REACT_APP_WORKING_DOCS_LINK_INF_LIST_ID"
    | "REACT_APP_DEPARTMENTS_LIST_ID"
    | "REACT_APP_LOOKUPDATA_LIST_ID"
    | "REACT_APP_CONFIGS_LIST_ID"
    | "REACT_APP_DOCUMENT_TEMPLATES_LIST_ID"
    | "REACT_APP_DOCUMENT_CONTENTS_LIST_ID"
    | "REACT_APP_NOTIFY_LIST_ID"
    | "REACT_APP_APPROVER_LEAVE_REQUESTS_URL"
    | "REACT_APP_AUTHOR_LEAVE_REQUESTS_URL"
    | "REACT_APP_APPROVER_IT_CODE_REQUESTS_URL"
    | "REACT_APP_APPROVER_TRANING_PLAN_URL"
    | "REACT_APP_AUTHOR_TRANING_PLAN_URL"
    | "REACT_APP_EPR_CODE_REQUEST_SP_LIST_ID"
    | "REACT_APP_IT_TOOLS_SP_LIST_ID"
    | "REACT_APP_IT_TOOLS_REQUEST_SP_LIST_ID"
    | "REACT_APP_IT_ACCOUNT_TYPE_SP_LIST_ID"
    | "REACT_APP_IT_DELETEACCOUNT_REQUEST_SP_LIST_ID"
    | "REACT_APP_IT_CODETSCC_SP_LIST_ID"
    | "REACT_APP_IT_REPAIR_INFO_SP_LIST_ID"
    | "REACT_APP_IT_TSCC_SP_LIST_ID"
    | "REACT_APP_IT_INSTRUMENTS_SP_LIST_ID"
    | "REACT_APP_BUSINESS_TICKET_REQUEST_LIST_ID"
    | "REACT_APP_BUSNIESS_VEHICLE_REQUEST_LIST_ID"
    | "REACT_APP_SECURITY_CONTROL_TICKET_REQUEST_LIST_ID"
    | "REACT_APP_TRAVEL_CARD_REQUEST_LIST_ID"
    | "REACT_APP_EXTERNAL_TRAVEL_CARD_REQUEST_LIST_ID"
    | "REACT_APP_EXTERNAL_SERCURITY_CONTROL_TICKET_REQUEST_LIST_ID"
    | "REACT_APP_APPLICATION_FOR_LEAVE_LIST_ID"
    | "REACT_APP_ACCIDENT_INVESTIGATION_RECORD_LIST_ID"
    | "REACT_APP_CONFIRM_EMPLOYEE_REQUESTS_LIST_ID"
    | "REACT_APP_CHANGE_PERSON_REQUEST_LIST_ID"
    | "REACT_APP_TRAINING_COURSE_MONTHLY_LIST_ID"
    | "REACT_APP_MONTHLY_TRAINING_PLAN_SUMMARY_SP_LIST_ID"
    | "REACT_APP_TRAINEE_BY_COURSE_LIST_ID"
    | "REACT_APP_TRAINING_COURSE_PLANE_LIST_ID"
    | "REACT_APP_TRAINING_COURSE_ITEM_TEMPLATE_ID"
    | "REACT_APP_TRAINING_COURSE_PARENT_DRIVE_ID"
    | "REACT_APP_TRAINING_COURSE_PARENT_ID"
    | "REACT_APP_DOCUMENT_PERMISSION_DEFAULT_USER_ID_LIST_ID"
    | "REACT_APP_DOCUMENT_TAGS_LIST_ID"
    | "REACT_APP_EXTERNAL_TRAVEL_CARD_REQUEST_LIST_ID"
    | "REACT_APP_STATISTIC_INDEX_LIST_ID"
    | "REACT_APP_DOCUMENT_CONTENTS_LINK_LIST_ID"
    | "REACT_APP_DECENTRALIZATION_SP_LIST_ID"
    | "REACT_APP_DOCUMENT_FOLDER_ROOT_ID"
    | "REACT_APP_APPROVER_SABRE_EPR_REQUEST_URL"
    | "REACT_APP_APPROVER_IT_TOOLS_REQUEST_URL"
    | "REACT_APP_APPROVER_DELETE_ACCOUNT_REQUEST_URL"
    | "REACT_APP_APPROVER_IT_TOOLS_REPAIR_REQUEST_URL"
    | "REACT_APP_APPROVER_BUSINESS_VEHICLE_REQUEST_URL"
    | "REACT_APP_APPROVER_BUSINESS_TICKET_REQUEST_URL"
    | "REACT_APP_APPROVER_SECURITY_CONTROL_CARD_REQUEST_URL"
    | "REACT_APP_APPROVER_SECURITY_CONTROL_CARD_TO_EXTERNAL_REQUEST_URL"
    | "REACT_APP_APPROVER_BUSINESS_VEHICLE_CARD_REQUEST_URL"
    | "REACT_APP_DOCUMENT_DETAILS_URL"
    | "REACT_APP_APPROVER_BUSINESS_EXTERNAL_VEHICLE_CARD_REQUEST_URL"
    | "REACT_APP_IT_TOOL_EVICT_LIST_ID"
    | "REACT_APP_APPROVER_CHANGE_PERSON"
    | "REACT_APP_PLANNING_DEPARTMENT_EXPORT_WAREHOUSE"
    | "REACT_APP_APPROVER_RECALL_TOOL_PLANNING_DEPARTMENT"
    | "REACT_APP_APPROVER_EXPORT_WAREHOUSE_PLANNING_DEPARTMENT"
    | "REACT_APP_APPROVER_AFL_URL"
    | "REACT_APP_SUMMARY_EMPLOYEE_REQUEST_LIST_ID"
    | "REACT_APP_SUMMARY_EMPLOYEE_REQUEST"
    | "REACT_APP_SUMMARY_REGISTER_REQUEST_LIST_ID"
    | "REACT_APP_SUMMARY_REGISTER_REQUEST"
    | "REACT_APP_MEETING_REQUEST_LIST_ID"
    | "REACT_APP_BUSINESS_CARD_REQUEST_LIST_ID"
    | "REACT_APP_STATIONERY_REQUEST_LIST_ID"
    | "REACT_APP_DOMAIN_URL"
    | "REACT_APP_MEETING_REQUEST"
    | "REACT_APP_STATIONARY_REQUEST"
    | "REACT_APP_DOCUMENT_SERVICE_URL"
    | "REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_DRIVE_ID"
    | "REACT_APP_ONESIGNAL_ID"
    | "REACT_APP_CHAT_API_DOMAIN"
    | "REACT_APP_BACK_OFFICE_URI"
    | "REACT_APP_EOFFICE_API_URL"
    | "REACT_APP_ANDROID_APP_URL"
    | "REACT_APP_IOS_APP_URL"
    | "REACT_APP_X_API_KEY",
): string {
  return process.env[key] as any;
}

export const isDev = getEnv("REACT_APP_ENV") !== "production";
